export default function Installation() {
  return (
    <div>
      <p>
        The DISGENET Cytoscape App is available from the Cytoscape App Store:
        <a href="https://apps.cytoscape.org/apps/disgenetapp" target="_blank" rel="noreferrer">
          {' '}
          https://apps.cytoscape.org/apps/disgenetapp
        </a>
      </p>
    </div>
  );
}
